import { type FormatOptions, formatCurrency } from '@ps/web-poker-utils';

interface Range {
  range: number[];
  currency: string | number;
  separator?: string;
  options?: FormatOptions;
}

export default function rangeFormatter({ range, currency, separator = '/', options }: Range) {
  const formattedRange = range.map((amount) => formatCurrency(amount, currency, options));

  if (formattedRange.length === 1) {
    return formattedRange.join().concat(separator);
  }
  return formattedRange.join(` ${separator} `);
}
